export const REQUEST_TRAINING_VIDEOS_DATA = 'REQUEST_TRAINING_VIDEOS_DATA';
export const RECEIVE_TRAINING_VIDEOS_DATA = 'RECEIVE_TRAINING_VIDEOS_DATA';

export const receiveTrainingVideosData = (payload) => ({
  type: RECEIVE_TRAINING_VIDEOS_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/trainingVideosActions.js